// extracted by mini-css-extract-plugin
module.exports = {"controlButton":"_38_je","hidden":"ZnOJP","container":"_2OeOV","fillAllSpace":"_2SCMs","fullScreen":"xieeb"};